import { render, staticRenderFns } from "./BaseLoadingPopUp.vue?vue&type=template&id=492ca48e&scoped=true&"
import script from "./BaseLoadingPopUp.vue?vue&type=script&lang=js&"
export * from "./BaseLoadingPopUp.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoadingPopUp.vue?vue&type=style&index=0&id=492ca48e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492ca48e",
  null
  
)

export default component.exports